import React from "react";
import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, TEXT_AREA } = FIELD_TYPE;

const cssProps = {
  css: { xl: 24, md: 24 },
  labelCol: { xl: 4, md: 8 },
  wrapperCol: { xl: 20, md: 14 },
};

const fields: DataFormField[] = [
  {
    label: "Trạng thái",
    name: "tenTTCSKH",
    type: INPUT,
    ...cssProps,
  },
  {
    label: "Thời gian",
    type: INPUT,
    name: "toSeconds",
    suffix: "ngày",
    ...cssProps,
  },
  {
    label: "Mô tả",
    type: TEXT_AREA,
    name: "moTa",
    ...cssProps,
  },
];

const allColumns: ColumnsEdit = [
  { title: "Trạng thái", dataIndex: "tenTTCSKH", align: "left", width: "15%" },
  {
    title: "Thời gian",
    dataIndex: "toSeconds",
    show: true,
    align: "center",
    width: "15%",
    
  },

  {
    title: "Mô tả",
    dataIndex: "moTa",
    show: true,
    align: "left",
    width: "65%",
  },

  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    align: "center",
    show: true,
    width: "5%",
  },
];

export { allColumns, fields };
